import { ComingSoon } from './components/ComingSoon';
import { SkipLink } from './components/SkipLink';
import { BrandFooter } from './components/BrandFooter';

export function App() {
  return (
    <div className="flex min-h-screen flex-col">
      <SkipLink />
      <main
        id="main"
        tabIndex={-1}
        className="mx-auto flex w-full max-w-3xl flex-1 flex-col items-center justify-center px-6 py-12 text-center"
      >
        <ComingSoon />
      </main>
      <BrandFooter />
    </div>
  );
}
